const SomethingWentWrongComponent = () => (
  <div
    style={{
      backgroundColor: 'whitesmoke',
      display: 'flex',
      minHeight: '100vh',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <div style={{ textAlign: 'center' }}>
      <h1 style={{ fontSize: '12rem' }}>OOPS!</h1>
      <p style={{ fontSize: '2rem' }}>Oops something went wrong!</p>
      <a href='/' className='link_404'>
        Go Home
      </a>
    </div>
  </div>
)
export default SomethingWentWrongComponent
